import { Container, Grid } from '@mui/material';
import React from 'react';
import UserProjectSection from '../../components/MyProfile/user-projects/UserProjectSection';
import NewLayout from '../../layout/dashboard/NewLayout';
import AssignedProjects from '../../components/MyProfile/user-projects/AssignedProjects';
import { useAccess } from '../../hooks/useAccess'; 
import Loader from '../../components/elements/Loader';

const UserProjectsPage = () => {
  const { canAccess, isReady } = useAccess();
  if (!isReady) {
    return <Loader />;
  }

  return (
    <NewLayout>
      <Container maxWidth="xxl">
        <Grid container spacing={2}>
          <Grid item md={12}>
            {canAccess('ManageProjects') ? (
              <UserProjectSection />
            ) : (
              <AssignedProjects />
            )}
          </Grid>
        </Grid>
      </Container>
    </NewLayout>
  );
};

export default UserProjectsPage;
